import TransformModel from './TransformModel';

export default class LinkLineModel extends TransformModel {

}
